import React, {useEffect, useRef, useState} from 'react';
import * as Logo from '../../icon/Logo';
import {HeaderPushContent} from './index';
import {TopBanner} from './TopBanner';

export const HeaderWithoutNavigation = ({topBanner}: {topBanner: {isVisible?: boolean; text?: string}}) => {
  const bannerElementRef = useRef<HTMLDivElement>();
  const [bannerHeight, setBannerHeight] = useState(0);

  useEffect(() => {
    setBannerHeight(bannerElementRef.current?.offsetHeight);
  }, []);

  return (
    <>
      <header data-testid='header-without-navigation' className='z-10 fixed w-full top-0'>
        {topBanner.isVisible && <TopBanner forwardedRef={bannerElementRef} text={topBanner.text} />}
        <div className='bg-white shadow-2xl'>
          <div className='container max-w-screen-xl max-lg:px-3 bg-white '>
            <div className='flex h-70px justify-between'>
              <div className='h-full flex'>
                <div data-testid='navbar-logo' className='w-auto flex items-center'>
                  <Logo.Big />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <HeaderPushContent hasBlogMenu={false} showTopBanner={topBanner.isVisible} bannerHeight={bannerHeight} />
    </>
  );
};
